import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const JourneyCardsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',
  maxWidth: '1300px',
  overflow: 'visible',

  [theme.breakpoints.down('lg')]: {
    maxWidth: '1100px',
  },

  [theme.breakpoints.down('md')]: {
    maxWidth: '700px',
  },

  [theme.breakpoints.down('sm')]: {
    maxWidth: '500px',
  },

  [theme.breakpoints.down(500)]: {
    maxWidth: '100%',
    padding: '0 16px',
  },
}));
